import { Theme } from '@blockanalitica/ui/package/types/src/theme/ThemeProvider';
import { ComponentStyle } from '@blockanalitica/ui/package/types/src/theme/types';

export function dropdownHeader(theme: Theme): ComponentStyle {
  return {
    componentName: 'dropdownHeader',
    baseStyle: {
      border: `solid 1px ${theme.colors.spark.gray90}`,
      display: 'flex',
      borderRadius: theme.sizes['-3'],
      backgroundColor: theme.colors.foreground,
      gap: theme.space['xs'],
      fontSize: theme.sizes['-1'],
      fontWeight: 500,
      padding: `${theme.space['2xs']} ${theme.space['xs']}`,
      flex: 1,
      boxSizing: 'border-box',
      height: '100%',

      ['&::placeholder']: {
        color: theme.colors.muted
      }
    }
  };
}
